// extracted by mini-css-extract-plugin
export var avatarContainer = "_5w-1";
export var largeAvatarContainer = "_5w-2";
export var smallAvatarContainer = "_5w-0";